import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot, Slottable } from '../slot';
import type { CarouselHeadingAreaPropsInterface } from './types/carousel-heading-area.types';

/**
 * @since 10.0.0
 */
export const CarouselHeadingArea = forwardRef<HTMLDivElement, CarouselHeadingAreaPropsInterface>(
  (props: CarouselHeadingAreaPropsInterface, forwardedRef) => {
    const { asChild = false, children, className, css: cssProp, ...rest } = props;
    const styles = css(cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Carousel.HeadingArea"
        className={cx('c11n', 'c11n_carousel__heading-area', styles, className)}
        {...rest}
      >
        <Slottable>{children}</Slottable>
      </Component>
    );
  },
);

CarouselHeadingArea.displayName = 'Carousel.HeadingArea';
